import axios from "axios";

const PR_API_BASE_URL = "https://prmsv2.peaceradio.com/v2/api/";

function cleanParams(params = {}) {
  const cleaned = {};
  Object.keys(params).forEach((k) => {
    const v = params[k];
    if (v === undefined || v === null || v === "") return;
    cleaned[k] = v;
  });
  return cleaned;
}

class PeaceRadioService {
  constructor() {
    this.http = axios.create({
      baseURL: PR_API_BASE_URL,
    });
  }

  getDistricts() {
    return this.http.get("district");
  }

  getZones(districtId) {
    return this.http.get(`zone/${districtId}`);
  }

  getUnits(zoneId) {
    return this.http.get(`unit/${zoneId}`);
  }

  getCourses() {
    return this.http.get("guide-courses");
  }

  getMadrasas(params = {}) {
    return this.http.get("madrasa-list", { params: cleanParams(params) });
  }

  getCandidates(params = {}) {
    return this.http.get("guide-candidates", { params: cleanParams(params) });
  }
}

export default new PeaceRadioService();

